<template lang="pug">
UiModal(
  :show="show"
  @close="close"
  :title="$t('companies.create_title')"
  :rightActions="rightActions"
)
  UiFormGroup(
    :label="$t('companies.basic.name')"
    :vuelidateModel="v$.form.company_name"
  )
    UiInput#company-name-input(
      v-model="form.company_name"
      :error="v$.form.company_name.$error"
    )
  UiFormGroup(
    :label="$t('companies.softwares.basware_company_id')"
    :vuelidateModel="v$.form.basware_company_id"
  )
    UiInput#business-id-input(
      v-model="form.basware_company_id"
      :error="v$.form.basware_company_id.$error"
    )
</template>

<script>
import ApiCompanies from "@/api/companies.js";
import useVuelidate from "@vuelidate/core";
import { required } from "@vuelidate/validators";

export default {
  setup() {
    return {
      v$: useVuelidate(),
    };
  },

  validations() {
    return {
      form: {
        company_name: {
          required,
        },
        basware_company_id: {
          required,
        },
      },
    };
  },

  data() {
    return {
      show: false,
      form: {},
    };
  },

  computed: {
    rightActions() {
      return [
        {
          label: this.$t("actions.save"),
          icon: "Check",
          onClick: this.save,
        },
      ];
    },
  },

  methods: {
    open(company) {
      this.v$.$reset();
      this.form = {
        parent_company_id: company.id,
      };
      this.show = true;
    },

    close() {
      this.show = false;
    },

    save() {
      this.v$.$validate().then((res) => {
        if (!res) return;
        const form = this.form;
        const params = {
          company_name: form.company_name,
          parent_company_id: form.parent_company_id,
          basware_company_id: form.basware_company_id,
        };
        ApiCompanies.cloneCompany(params)
          .then((result) => {
            this.$emit("done");
            this.close();
          })
          .catch((error) => {});
      });
    },
  },
};
</script>
